{
  "welcome": {
    "title": {
      "part1": "Your best companion for a ",
      "part2": "sober lifestyle",
      "part3": ""
    },
    "button": {
      "start": "Continue with my email",
      "login": "Access my account",
      "google": "Continue with Google"
    },
    "divider": {
      "or": "Or"
    },
    "google": {
      "errorTitle": "Couldn't continue",
      "errorMessage": "There was a problem signing in with Google. Please try again."
    }
  },
  "auth": {
    "login": {
      "title": "Sign in",
      "welcomeBack": "Sign in to access your account",
      "welcomeBackReturning": "It's great to have you back at Padrinho!",
      "member": "Member",
      "switchUser": "Switch",
      "email": "Email",
      "emailPlaceholder": "your@email.com",
      "password": "Password",
      "passwordPlaceholder": "Enter your password",
      "button": "Sign in",
      "forgot": "Forgot password?",
      "forgotPassword": "Forgot password?",
      "errorTitle": "Error",
      "errorFillFields": "Please fill in all fields",
      "errorInvalidCredentials": "Invalid credentials",
      "errorEmailNotConfirmed": "Email not confirmed",
      "errorTooManyAttempts": "Too many login attempts. Try again in a few minutes.",
      "errorConnection": "Connection error",
      "errorRetry": "Try again",
      "errorCancel": "Cancel",
      "errorConfig": "Configuration",
      "errorTemporary": "Temporary server error. Try again later.",
      "errorUnexpected": "Unexpected error",
      "errorUnexpectedMessage": "Unexpected error. Try again."
    },
    "forgotPassword": {
      "title": "Reset password",
      "subtitle": "Enter your email to receive password reset instructions",
      "email": "Email",
      "emailPlaceholder": "your@email.com",
      "button": "Send instructions",
      "buttonLoading": "Sending...",
      "errorTitle": "Error",
      "errorEmail": "Please enter your email",
      "errorRateLimit": "Attempt limit exceeded",
      "errorRateLimitMessage": "Too many password reset attempts were made. Please wait a few minutes before trying again.",
      "errorUserNotFound": "Email not found",
      "errorUserNotFoundMessage": "We couldn't find an account with this email",
      "successTitle": "Email sent",
      "successMessage": "Check your inbox to reset your password",
      "successButton": "OK",
      "errorUnexpected": "An unexpected error occurred"
    },
    "resetPassword": {
      "title": "New password",
      "subtitle": "Enter a new password for your account",
      "newPassword": "New password",
      "confirmPassword": "Confirm password",
      "newPasswordPlaceholder": "Enter your new password",
      "confirmPasswordPlaceholder": "Confirm your new password",
      "button": "Reset password",
      "buttonLoading": "Updating...",
      "errorTitle": "Error",
      "errorFillFields": "Please fill in all fields",
      "errorPasswordMismatch": "Passwords don't match",
      "errorInvalidPassword": "Invalid Password",
      "errorPasswordRequirements": "Your password must meet the following requirements:\n\n• Minimum 8 characters\n• One uppercase letter\n• One lowercase letter\n• One number",
      "errorGeneric": "Failed to reset password",
      "successTitle": "Password changed",
      "successMessage": "Your password has been changed successfully!",
      "successButton": "OK",
      "errorUnexpected": "An unexpected error occurred"
    },
    "verifyCode": {
      "title": "Enter verification code",
      "subtitle": "We sent a 6-digit code to {email}",
      "button": "Verify",
      "resendButton": "Resend code",
      "resendIn": "Resend in {timer}",
      "contactEmail": "contact@padrinho.app",
      "contactMessage": "Review the email used or get in touch:",
      "errorTitle": "Error",
      "successTitle": "Success",
      "errorDigits": "Please enter the 6-digit code",
      "errorInvalidCode": "Invalid or expired code",
      "errorVerification": "Verification error. Try again.",
      "errorResend": "Error resending code. Try again.",
      "successResend": "Success",
      "successResendMessage": "Code resent successfully!",
      "errorUnexpected": "Unexpected error. Please try again."
    },
    "setPassword": {
      "title": "Create your password",
      "subtitle": "Set a strong password to protect your account and access all Padrinho features",
      "password": "Password",
      "confirmPassword": "Confirm your password",
      "placeholder": "****",
      "button": "Create account",
      "buttonLoading": "Creating account...",
      "requirementsTitle": "Your password must have:",
      "requirementMinLength": "Minimum 8 characters",
      "requirementUppercase": "One uppercase letter",
      "requirementLowercase": "One lowercase letter",
      "requirementNumber": "One number",
      "errorTitle": "Error",
      "errorPasswordMismatch": "Passwords do not match",
      "errorInvalidPassword": "Invalid Password",
      "errorPasswordRequirements": "Your password must meet the following requirements",
      "errorAccessRequired": "Access Required",
      "errorAccessRequiredMessage": "Please complete the email verification process.",
      "errorInvalidAccess": "Invalid Access",
      "errorInvalidAccessMessage": "Please complete the verification process again.",
      "errorSessionExpired": "Your session has expired. You will be redirected to start again.",
      "errorWeakPassword": "Password too weak. Please choose a stronger password with at least 8 characters, including uppercase, lowercase, and numbers.",
      "errorNetwork": "Internet connection error. Check your connection and try again.",
      "errorTimeout": "The operation took too long. Please check your connection and try again.",
      "errorSessionNotReceived": "There was a problem establishing your session. Please try again.",
      "errorGeneric": "Error creating your account. Please try again.",
      "errorSetPassword": "Error setting password. Please try again."
    },
    "sessionExpired": {
      "title": "Session expired",
      "message": "Your session has expired. Please sign in again to continue.",
      "button": "Sign in"
    }
  },
  "onboarding": {
    "title": "Start here",
    "sobrietySet": "Set your sobriety time",
    "firstMessage": "Start a conversation with Bill",
    "firstCheckin": "Join your first online meeting",
    "firstTrailStep": "Start your recovery trail",
    "firstDiaryNote": "Write in your diary",
    "profilePhoto": "Add your profile photo",
    "firstMessagePrompt": "Hello Bill, how can you help me?",
    "header": "Onboarding",
    "welcome": {
      "title": "Your path to a sober life starts today!",
      "subtitle": "Here in the app you will find excellent tools to support your progress",
      "button": "Okay, let's go!",
      "features": {
        "bill": "Bill, your personal assistant",
        "billDesc": "Smart conversations 24/7 for support and guidance",
        "diary": "Diary & Check-ins",
        "diaryDesc": "Record thoughts, feelings and attendance at online meetings",
        "clock": "Sobriety Clock",
        "clockDesc": "Mark your progress over time and celebrate every achievement",
        "progress": "Real-Time Progress",
        "progressDesc": "Track your progress day by day",
        "connection": "Connection with Clinics",
        "connectionDesc": "Direct communication with your service provider clinic",
        "privacy": "Total Privacy",
        "privacyDesc": "Your data is protected and confidential"
      }
    },
    "name": {
      "title": "To start, how can we call you?",
      "subtitle": "You can choose a nickname",
      "placeholder": "Enter your name or nickname",
      "required": "Name required",
      "requiredMessage": "Please enter your name or nickname.",
      "error": "Error",
      "errorMessage": "Could not save your name. Try again."
    },
    "interests": {
      "title": "What topics are you interested in?",
      "titleWithName": "what topics are you interested in?",
      "subtitle": "Choose at least 3 topics of interest",
      "insufficient": "Insufficient Selection",
      "insufficientMessage": "Please choose at least 3 topics of interest.",
      "error": "Error",
      "errorMessage": "Could not save your interests. Try again."
    },
    "gender": {
      "title": "What is your gender?",
      "subtitle": "Select the option that best represents you",
      "feminine": "Feminine",
      "masculine": "Masculine",
      "nonBinary": "Non-binary",
      "preferNotToSay": "Prefer not to say",
      "required": "Selection Required",
      "requiredMessage": "Please select an option.",
      "error": "Error",
      "errorMessage": "Could not save your preference. Try again."
    },
    "supportRecipient": {
      "title": "Today, who are you seeking support for?",
      "subtitle": "Select the option that best describes your situation",
      "self": "For myself",
      "friend": "For a friend",
      "family": "For a family member",
      "required": "Selection Required",
      "requiredMessage": "Please select an option.",
      "error": "Error",
      "errorMessage": "Could not save your preference. Try again."
    },
    "sponsorship": {
      "title": "Would you like to have a sponsor?",
      "subtitle": "Choose an option about sponsorship",
      "godmother": "Yes, a godmother",
      "godfather": "Yes, a godfather",
      "maybeLater": "Maybe later",
      "dontWant": "I don't want",
      "required": "Selection Required",
      "requiredMessage": "Please select an option.",
      "error": "Error",
      "errorMessage": "Could not save your preference. Try again."
    },
    "addictionType": {
      "title": "What type of addiction do you currently identify with?",
      "subtitle": "You can select more than 1 option",
      "options": {
        "alcohol": "Alcohol",
        "nicotine": "Nicotine",
        "drugs": "Drugs / Psychoactives",
        "gambling": "Gambling",
        "sex": "Sex",
        "pornography": "Pornography",
        "other": "Other"
      },
      "required": "Selection Required",
      "requiredMessage": "Please select at least one option.",
      "error": "Error",
      "errorMessage": "Could not save your selection. Try again."
    },
    "frequency": {
      "title": "How often do you resort to your addiction?",
      "options": {
        "onceWeek": "Once a week",
        "twoThreeWeek": "2 to 3 times a week",
        "fourFiveWeek": "4 to 5 times a week",
        "daily": "Every day",
        "alreadySober": "I'm already sober",
        "notAddicted": "I'm not addicted"
      },
      "required": "Selection Required",
      "requiredMessage": "Please select an option.",
      "error": "Error",
      "errorMessage": "Could not save your selection. Try again."
    },
    "goal": {
      "title": "What is your main goal within Padrinho?",
      "options": {
        "reduceControl": "Reduce or control compulsive behavior",
        "fullAbstinence": "Achieve complete abstinence",
        "maintainSobriety": "Maintain sobriety or daily balance",
        "identifyTriggers": "Identify triggers and build coping strategies",
        "healthyHabits": "Develop healthy habits as substitutes",
        "rebuildRelationships": "Rebuild or strengthen relationships and support networks",
        "monitorProgress": "Monitor my own progress and celebrate small victories"
      },
      "required": "Selection Required",
      "requiredMessage": "Please select an option.",
      "error": "Error",
      "errorMessage": "Could not save your selection. Try again."
    },
    "notifications": {
      "title": "Can we send you some notifications?",
      "subtitle": "Just to build a great connection, we won't send SPAM, we promise!",
      "button": "Sure! Send them"
    },
    "success": {
      "welcomeMessage": "{name}, welcome to Padrinho!",
      "welcomeMessageFallback": "Name, welcome to Padrinho!",
      "recoveryMessage": "Your recovery continues today, {date}",
      "buttonStart": "Get Started",
      "buttonRetry": "Try Again",
      "greeting": "So glad you're here,",
      "joinPrefix": "Join ",
      "joinHighlight": "over {count} people online",
      "joinSuffix": " now for sharing and support",
      "uploadPhoto": "Upload profile photo",
      "uploading": "Uploading photo...",
      "buttonContinue": "Ok, let's go!"
    },
    "firstAccess": {
      "stepNumber": "6",
      "title": "Connect to Padrinho",
      "subtitle": "Enter the email you will use to access your Padrinho account",
      "emailLabel": "Email",
      "emailPlaceholder": "Enter your email",
      "termsTitle": "Terms and Privacy Policies",
      "termsAccept": "I accept the ",
      "termsLink": "terms and privacy policies",
      "termsAppName": " of the Padrinho app.",
      "errors": {
        "emailRequired": "Error",
        "emailRequiredMessage": "Please enter your email",
        "emailInvalid": "Error",
        "emailInvalidMessage": "Please enter a valid email",
        "termsRequired": "Error",
        "termsRequiredMessage": "You must accept the terms to continue",
        "userExists": "Account Exists",
        "userExistsMessage": "An account with this email already exists. Please sign in using your password.",
        "cancel": "Cancel",
        "goToLogin": "Go to Login",
        "sendError": "Error",
        "sendErrorMessage": "Error sending verification code. Please try again.",
        "unexpectedError": "Error",
        "unexpectedErrorMessage": "An unexpected error occurred. Please try again."
      }
    }
  },
  "sobriety": {
    "card": {
      "title": "Sobriety clock",
      "setupDescription": "Count your days in sobriety",
      "todayLabel": "Today, {month} {day}",
      "hoursLabel": "+ 24 hours",
      "daysMessage": "You are {days} {daysWord} sober!",
      "day": "day",
      "days": "days",
      "congratsTitle": "Congratulations! You've stayed sober",
      "year": "year",
      "years": "years",
      "month": "month",
      "months": "months",
      "dayLabel": "day",
      "daysLabel": "days",
      "hour": "hour",
      "hours": "hours",
      "share": "Share",
      "restart": "Restart",
      "edit": "Edit",
      "totalDaysMessage": "You are {days} days sober",
      "totalDaysPrefix": "You are ",
      "totalDaysSuffix": " sober",
      "totalDaysWord": "days",
      "addWidget": "Add to Home Screen"
    },
    "share": {
      "message": "I've been sober for {days} days! 🎉 #Padrinho #Sobriety",
      "imageText": "Today I am completing\n{days} days in sobriety"
    },
    "clock": {
      "title": "Sobriety clock",
      "cancel": "Cancel",
      "question": "Tell us about your current moment",
      "option1": "I had a relapse and I'm restarting",
      "option2": "I've been sober for a while",
      "option3": "I'm starting today",
      "continue": "Continue"
    },
    "input": {
      "title": "Sobriety clock",
      "subtitle": "When was the last time you drank?",
      "placeholder": "MM/DD/YYYY",
      "helperText": "Enter the date in MM/DD/YYYY format",
      "daysLabel": "Days of sobriety",
      "button": "Start counting",
      "invalidDate": "Invalid date",
      "futureDate": "Date cannot be in the future"
    },
    "relapse": {
      "title": "Sobriety clock",
      "mainTitle": "Remember, relapses are part of the process",
      "subtitle": "What matters most are your achievements and learnings so far",
      "reminderButton": "Write a reminder",
      "continueButton": "Continue",
      "noteTitle": "Reminder about relapse"
    },
    "congratulations": {
      "title": "Sobriety clock",
      "mainTitle": "Congratulations! Today you begin an important moment in your journey",
      "subtitle": "Remember, what matters are your achievements and learnings so far",
      "button": "Okay, let's go!"
    },
    "shareCard": {
      "line1": "Today I am completing",
      "days": "days",
      "line2": "in sobriety"
    },
    "sharePage": {
      "title": "Sobriety clock",
      "shareButton": "Share via message",
      "saveButton": "Download",
      "sharing": "Sharing...",
      "saving": "Saving...",
      "savedTitle": "Image saved",
      "savedMessage": "The image has been saved to your gallery",
      "errorTitle": "Error",
      "errorMessage": "Could not process the image. Please try again.",
      "permissionDeniedTitle": "Permission denied",
      "permissionDeniedMessage": "We need permission to save to your gallery",
      "sharingUnavailableTitle": "Sharing unavailable",
      "sharingUnavailableMessage": "Sharing is not available on this device",
      "shareDialogTitle": "Share achievement"
    }
  },
  "navbar": {
    "bill": "Bill",
    "meetings": "Meetings"
  },
  "bill": {
    "welcome": {
      "title": "Hi, I'm Bill",
      "subtitle": "Your digital sponsor"
    },
    "loading": {
      "connecting": "Bill is responding...",
      "typing": "Typing..."
    },
    "suggestions": {
      "startTrail": "Start my trail",
      "diaryGuide": "How to use my diary",
      "meetingTimes": "Meeting times"
    },
    "input": {
      "placeholder": "Send your message to Bill"
    },
    "plusBar": {
      "continueConversation": "Continue chatting with Bill",
      "remainingMessages": "You still have ",
      "remainingMessagesEnd": " messages",
      "sendMessage": "Send your message to Bill"
    },
    "errors": {
      "technicalIssue": "Sorry, I had a technical problem processing your message. Can you try again?",
      "monthlyLimitReached": "You've reached your monthly message limit. Upgrade to Padrinho Plus for unlimited conversations with Bill."
    }
  },
  "chat": {
    "title": "Bill - Your Assistant",
    "placeholder": "Write your message...",
    "send": "Send",
    "typing": "Bill is typing...",
    "empty": "Start a conversation with Bill",
    "error": "Error sending message",
    "connecting": "Connecting with Bill...",
    "messageTitle": "Message from Bill",
    "today": "Today",
    "yesterday": "Yesterday",
    "suggestedActions": {
      "startTrail": "Start my trail",
      "diaryGuide": "How to use my diary"
    },
    "contextMenu": {
      "share": "Share",
      "bookmark": "Save",
      "remove": "Remove",
      "edit": "Edit"
    },
    "clearConversation": {
      "title": "New conversation",
      "message": "This will clear your current conversation with Bill. Your saved messages in the diary will be kept. You can start fresh anytime.",
      "confirm": "Start new conversation"
    }
  },
  "diary": {
    "headerTitle": "Diary",
    "title": "Wellness Diary",
    "tabs": {
      "relogio": "Clock",
      "notas": "Notes",
      "missoes": "Missions"
    },
    "clock": {
      "emptyTitle": "Track your sobriety days",
      "startButton": "Start counting",
      "communityCount": "You and {count} people are in recovery",
      "share": "Share",
      "restart": "Restart",
      "edit": "Edit",
      "anos": "Years",
      "meses": "Months",
      "dias": "Days",
      "horas": "Hours",
      "shareMessage": "days sober! 🎉 #Padrinho"
    },
    "addEntry": "New Entry",
    "mood": "How are you feeling?",
    "gratitude": "What are you grateful for?",
    "notes": "Notes",
    "save": "Save",
    "delete": "Delete",
    "empty": "No entries yet",
    "emptyState": {
      "notesTitle": "Record a reflection for today",
      "notesButton": "Create note",
      "title": "Save your memories along your journey",
      "subtitle": "Here you can record thoughts, feelings, or save messages from Bill to remember in the future"
    },
    "today": "Today",
    "yesterday": "Yesterday",
    "noteDeleted": "Note deleted successfully!",
    "checkinRemoved": "Check-in removed successfully!",
    "checkinHidden": "Check-in hidden from diary successfully!",
    "relapseHidden": "Entry hidden from diary successfully!",
    "messageRemoved": "Message removed from diary successfully!",
    "relapse": {
      "title": "Start Over",
      "message": "Relapses are part of the process! Keep going from where you left off"
    },
    "deleteError": "Error deleting. Please try again.",
    "removeMessageError": "Error removing message. Please try again.",
    "sentimentLabel": "Feeling",
    "contextLabel": "Context",
    "checkinText": "Check-in 📍 You attended the {meetingName} meeting at {time}",
    "filters": {
      "author": "Author",
      "period": "Period",
      "sentiment": "Feeling",
      "sentimentMultiple": "{count} feelings",
      "you": "You",
      "bill": "Bill",
      "last7days": "Last 7 days",
      "last15days": "Last 15 days",
      "last30days": "Last 30 days",
      "all": "All",
      "search": "Search your notes..."
    },
    "actions": {
      "options": "Options",
      "editEntry": "Edit entry",
      "deleteEntry": "Delete entry",
      "editNote": "Edit note",
      "deleteNote": "Delete note",
      "removeCheckin": "Remove check-in",
      "hideFromDiary": "Hide from diary",
      "removeFromDiary": "Remove from diary"
    },
    "buttons": {
      "sentiment": "Feeling",
      "note": "Note"
    },
    "search": {
      "cancel": "Cancel",
      "results": "{count} result found",
      "resultsPlural": "{count} results found"
    },
    "emotions": {
      "feliz": "Happy",
      "animado": "Excited",
      "tranquilo": "Calm",
      "cansado": "Tired",
      "frustrado": "Frustrated",
      "triste": "Sad",
      "estressado": "Stressed",
      "irritado": "Irritated",
      "ansioso": "Anxious"
    },
    "categories": {
      "vida-pessoal": "Personal Life",
      "trabalho": "Work",
      "relacionamentos": "Relationships",
      "saude": "Health",
      "financas": "Finances",
      "sobriedade": "Sobriety",
      "lazer": "Leisure",
      "espiritualidade": "Spirituality",
      "educacao": "Education",
      "outros": "Other",
      "and": "and"
    },
    "sentiment": {
      "title": "Feeling",
      "question": "How are you feeling today?",
      "nextButton": "Next",
      "writeMemory": "Write a memory about this feeling",
      "context": "In what context do you feel this way?",
      "savedSuccess": "recorded successfully! 💚",
      "noteSavedSuccess": "Note saved successfully!",
      "noteUpdatedSuccess": "Note updated successfully!",
      "cannotEdit": "Check-ins cannot be edited, only removed.",
      "removed": "Check-in removed successfully!",
      "hidden": "Check-in hidden from diary successfully!",
      "deleted": "Feeling record deleted successfully!",
      "error": "Error deleting record. Try again.",
      "removeError": "Error removing message. Try again.",
      "placeholderWithCategory": "I'm feeling {emotion} about {category}...",
      "placeholderNoCategory": "I'm feeling {emotion}...",
      "contextLabel": "Context:"
    },
    "addNote": {
      "titleNew": "New note",
      "titleEdit": "Edit note",
      "titleEditEntry": "Edit entry",
      "placeholder": "What's on your mind right now?",
      "userFallback": "User"
    }
  },
  "meetings": {
    "title": "Meetings",
    "tabs": {
      "explore": "Explore",
      "saved": "Saved",
      "para_voce": "For You"
    },
    "salvos": {
      "empty": {
        "title": "No saved meetings yet",
        "subtitle": "Tap the heart on any meeting to find it here later.",
        "cta": "Explore meetings"
      }
    },
    "filters": {
      "time": "Time",
      "day": "Day of week",
      "category": "Category",
      "clear": "Clear filters"
    },
    "time": {
      "todayAt": "Today at"
    },
    "sections": {
      "happeningNow": "Happening now",
      "suggested": "Suggested for you",
      "otherMeetings": "Other meetings"
    },
    "empty": {
      "title": "You haven't saved a meeting yet",
      "subtitle": "Save a meeting so you can remember it later!"
    },
    "search": {
      "placeholder": "Search by name, type or platform...",
      "cancelButton": "Cancel",
      "results": "{count} result found",
      "resultsPlural": "{count} results found",
      "preset1": "Path Group",
      "preset2": "Sharing"
    },
    "actions": {
      "favorite": "Favorite",
      "favorited": "Favorited",
      "unfavorite": "Unfavorite",
      "enter": "Enter",
      "invite": "Invite"
    },
    "sectionTitles": {
      "upcoming": "Upcoming meetings"
    },
    "status": {
      "liveNow": "Live now",
      "live": "Live"
    },
    "carousel": {
      "title": "Online meetings",
      "viewAll": "View all",
      "loading": "Loading upcoming meetings...",
      "empty": "No upcoming meetings found"
    },
    "labels": {
      "password": "Password",
      "schedule": "Schedule",
      "place": "Platform",
      "participants": "Participants"
    },
    "detail": {
      "infoTitle": "Meeting information",
      "totalParticipations": "total check-ins",
      "liveNow": "Live now",
      "at": "at",
      "tipsTitle": "Meeting tips",
      "tipCamera": "You don't need to turn on your camera",
      "tipMute": "You can just listen, no one will call you by name",
      "tipHeart": "People there are just like you: getting better one day at a time",
      "tipHonesty": "There's no right or wrong — just honesty",
      "tipLeave": "If you feel like it, you can leave the meeting at any time",
      "programacao": "Schedule",
      "programacaoCount": "{count} weekly meetings",
      "programacaoCountOne": "1 weekly meeting",
      "programacaoSingleSession": "Single session",
      "programacaoRow": "{weekday} · {time} · {category}"
    },
    "form": {
      "title": {
        "new": "New Meeting",
        "edit": "Edit Meeting"
      },
      "fields": {
        "name": {
          "label": "Meeting Name *",
          "placeholder": "Ex: Morning Support Circle"
        },
        "link": {
          "label": "Meeting Link *",
          "placeholder": "https://zoom.us/j/123456789"
        },
        "time": {
          "label": "Time *",
          "placeholder": "Ex: 08:00"
        },
        "category": {
          "label": "Category *"
        },
        "group": {
          "label": "Group",
          "noGroups": "No groups available"
        },
        "weekdays": {
          "label": "Weekdays *"
        },
        "platform": {
          "label": "Platform *",
          "inPerson": "In-Person"
        },
        "period": {
          "label": "Period *"
        },
        "region": {
          "label": "Region",
          "placeholder": "Ex: New York"
        },
        "password": {
          "label": "Meeting Password",
          "placeholder": "Optional password"
        },
        "description": {
          "label": "Description",
          "placeholder": "Meeting description"
        },
        "headerImage": {
          "label": "Header Image URL",
          "placeholder": "https://example.com/image.jpg",
          "hint": "Paste the full URL of the image that will appear in the meeting header"
        }
      },
      "categories": {
        "supportGroup": "Support Group",
        "workshop": "Workshop",
        "meditation": "Meditation",
        "therapy": "Therapy",
        "sharing": "Sharing",
        "reuniaoNovos": "Newcomers Meeting",
        "reuniaoPartilhas": "Sharing Meeting",
        "reuniaoTematica": "Themed Meeting",
        "reuniaoEstudoLiteratura": "Literature Study",
        "reuniaoAteusAgnosticos": "Atheists & Agnostics",
        "reuniaoLgbtqiapn": "LGBTQIAPN+",
        "reuniaoCodependentes": "Codependents",
        "reuniaoPassos": "Steps Meeting",
        "reuniaoTradicoes": "Traditions Meeting"
      },
      "platforms": {
        "zoom": "Zoom",
        "googleMeet": "Google Meet",
        "microsoftTeams": "Microsoft Teams",
        "jitsiMeet": "Jitsi Meet",
        "discord": "Discord",
        "inPerson": "In Person"
      },
      "actions": {
        "cancel": "Cancel",
        "saveChanges": "Save Changes",
        "create": "Create Meeting"
      }
    },
    "alerts": {
      "notFound": "Meeting not found",
      "loadError": "Failed to load meeting",
      "loginRequired": "You need to log in to enter the meeting",
      "linkNotAvailable": "Meeting link not available",
      "fillRequired": "Please fill in all required fields and select at least one weekday.",
      "saveError": "Failed to save meeting",
      "saveSuccess": "Meeting added successfully!",
      "updateSuccess": "Meeting updated successfully!",
      "genericError": "An error occurred while saving the meeting",
      "unauthorized": "Unauthorized access"
    },
    "share": {
      "greeting": "Hi! I would like to invite you to join a meeting with me. 🙏",
      "schedule": "Schedule",
      "link": "Link",
      "password": "Password",
      "downloadApp": "Or download the Padrinho app at www.padrinho.app/downloads"
    },
    "clipboard": {
      "passwordCopied": "Password copied!"
    },
    "errors": {
      "loading": "Error loading meetings",
      "loadingSaved": "Error loading saved meetings",
      "updateSaved": "Error updating saved meeting",
      "loadMeetingInfo": "Unable to load meeting information"
    },
    "errorLoading": "Error loading meetings",
    "errorLoadingSaved": "Error loading saved meetings",
    "saved_success": "Done! We'll notify you when this meeting starts.",
    "removed": "Meeting removed from saved!",
    "loginToSave": "Log in to save meetings",
    "onboarding": {
      "welcome": {
        "title": "Hello {name}, welcome to meetings",
        "subtitle": "Here you can connect with people who share the same focus as you! But first, a few tips for participating.",
        "cta": "Let's go!",
        "accordion1": {
          "title": "What is a meeting?",
          "content": "Attending a meeting may feel difficult at first, but it is one of the most important steps for anyone who wants to change their life. Meetings are safe spaces where people like you share experiences, strength and hope. You hear how they dealt with addiction, how they found solutions to everyday conflicts and how they are building a better life today."
        },
        "accordion2": {
          "title": "What happens at a meeting?",
          "content": "At the start, the coordinator gives a brief opening and, in some meetings, there is a moment of silence or the Serenity Prayer. You can — if you want — say it is your first time, but that is not required. Then we listen to reflections, shares and, at the end, there is a moment of unity or a reading that reinforces the collective commitment.\n\nWhen the meeting ends, many people stay to chat. You decide whether you want to join that — no pressure."
        },
        "accordion3": {
          "title": "Why participate?",
          "content": "Going to a meeting is not just \"showing up\"; it is investing in yourself. Here are immediate benefits you can feel as early as your first visit:\n\n1. The meeting brings real solutions to daily life.\nBy hearing other stories, new perspectives emerge for dealing with conflicts, emotions and challenges that once seemed impossible.\n\n2. The meeting creates commitment — and commitment creates change.\nEntering the room, even in silence, is already a way to break old routines and build a new path.\n\n3. The meeting relieves the mind and the heart.\nTalking — or just listening — helps release the inner pressure. You leave feeling lighter, calmer and more prepared."
        }
      },
      "step": "Question {current} of {total}",
      "next": "Next",
      "back": "Back",
      "q1": {
        "question": "To start, have you ever attended an anonymous group meeting before?",
        "options": {
          "never": "I have never attended",
          "once": "I attended once",
          "few_times": "I attended a few times",
          "long_periods": "I attended for long periods",
          "for_someone": "Not for me, but someone close to me attends"
        }
      },
      "q2": {
        "question": "What brought you here right now?",
        "options": {
          "iniciante": "I'm lost and need to understand if meetings can help me.",
          "novo": "I've heard about meetings and want to know how they work before joining.",
          "visitante": "I've been to a meeting but didn't have a good experience.",
          "recaido": "I want to start over after a relapse.",
          "itinerante": "I'm looking for a quality meeting to maintain my sobriety.",
          "codependente": "I'm here for someone I love."
        }
      },
      "q3": {
        "question": "What do you need most right now?",
        "options": {
          "courage": "Courage to take the first step",
          "information": "Information about how it works",
          "emotional_support": "Emotional support from people who understand",
          "talk_to_others": "Talk with others in recovery",
          "recovery_after_relapse": "Regain strength after a relapse",
          "learn_to_help": "Learn how to help someone I love"
        }
      },
      "result": {
        "title": "{name}, {count} meetings match you",
        "titleSingular": "{name}, 1 meeting matches you",
        "subtitle": "Join over {userCount} people online for sharing and support",
        "fallback": "Meetings for you",
        "fallbackSubtitle": "We're still categorizing meetings. Explore all of them below in the meantime.",
        "join": "Join",
        "explore": "See all meetings",
        "saving": "We're finding the best meetings for you"
      },
      "paraVoce": {
        "emptyTitle": "Personalizing your meetings",
        "emptySubtitle": "Complete the questionnaire to see meetings recommended for you.",
        "startOnboarding": "Personalize"
      }
    },
    "card": {
      "nextSession": "next session: {weekday} {time}"
    }
  },
  "trail": {
    "title": "Trail",
    "subtitle": "Your personal recovery journey",
    "step": "Step",
    "progress": "Progress",
    "complete": "Complete",
    "completed": "Completed",
    "description": "Description",
    "progressLabel": "Completed",
    "locked": "Locked",
    "lockedMessage": "Complete the previous step to unlock",
    "lockButtonText": "Continue",
    "reset": "Restart Trail",
    "resetConfirm": "Are you sure you want to restart your trail?",
    "resetTitle": "Restart Trail?",
    "resetMessage": "Are you sure you want to restart your trail?\n\nAll your progress will be lost and you'll return to the first step. This action cannot be undone.",
    "resetButton": "Yes, restart",
    "resetting": "Restarting...",
    "cancelButton": "Cancel",
    "intro": "Introduction",
    "introTitle": "The Trail",
    "introSubtitle": "Understand how it works",
    "introModalTitle": "How the Trail Works",
    "introModalMessage": "The Trail is a structured journey based on the recovery program.\n\nComplete each step in order to unlock the next one. Each step contains important content for your recovery journey.\n\nRead carefully and reflect on each stage before moving forward.",
    "introButton": "Got it",
    "lockedModalTitle": "Step Locked",
    "lockedModalMessage": "This step is still locked. Complete the previous steps to unlock this content.",
    "lockedButton": "Got it",
    "index": "Index",
    "actions": {
      "exit": "Exit",
      "completeReading": "Complete reading",
      "scrollToEnd": "Scroll to end",
      "listen": "Listen",
      "listening": "Listening"
    },
    "csat": {
      "title": "What did you think of the content?"
    },
    "hints": {
      "readToComplete": "Read to the end to complete this step"
    },
    "accessibility": {
      "pausePlayer": "Pause and open player",
      "listenStep": "Listen to step",
      "audioPlusGated": "Padrinho Plus exclusive audio — tap to learn more"
    },
    "congratulations": {
      "message": "Congratulations! You completed the",
      "completedStepMessage": "Congratulations! You completed the step {stepTitle} of the trail {trailName}"
    },
    "home": {
      "continueLearning": "Continue your trails",
      "suggestedTrails": "Trails for you",
      "newTrails": "What's new",
      "tabs": {
        "mine": "Started",
        "forYou": "For you",
        "explore": "Explore"
      },
      "steps": "steps",
      "favorite": "Save",
      "favorited": "Saved",
      "noMine": "You haven't started any trail yet",
      "noMineSubtitle": "Explore our trails and start your journey",
      "noForYou": "No suggested trails at the moment",
      "otherTrails": "Other trails",
      "started": "In progress",
      "iniciadas": {
        "emptyTitle": "Learn about recovery, start a trail",
        "emptyButton": "Explore trails"
      }
    },
    "category": {
      "trails": "Trails",
      "empty": "No trails in this category",
      "emptySubtitle": "New trails will be added soon"
    },
    "start": {
      "title": "Start trail",
      "steps": "lessons",
      "button": "Start trail",
      "plusButton": "Go Plus to access"
    },
    "audio": {
      "stepLabel": "Step {number}"
    }
  },
  "settings": {
    "title": "Settings",
    "profile": "Profile",
    "language": "Language",
    "notifications": "Notifications",
    "privacy": "Privacy",
    "about": "About",
    "logout": "Logout",
    "account": "Account"
  },
  "communityProfile": {
    "memberSince": "Member since {date}",
    "follow": "Follow",
    "following": "Following",
    "message": "Message",
    "posts": "Posts",
    "now": "Now",
    "minutesAgo": "{count}min",
    "hoursAgo": "{count}h",
    "yesterday": "Yesterday",
    "daysAgo": "{count}d",
    "editProfile": "Edit profile",
    "loading": "Loading...",
    "noPostsYet": "This user hasn't posted anything yet.",
    "noPostsYetSelf": "You haven't made any posts yet.",
    "anonymous": "Anonymous",
    "statsFollowing": "Following",
    "statsFriends": "Friends",
    "statsPosts": "Posts",
    "options": "Options",
    "editPost": "Edit post",
    "deletePost": "Delete post",
    "postRemovedSuccess": "Post removed successfully",
    "postRemoveError": "Error removing post",
    "recentlyParticipated": "Recently participated",
    "liveNow": "Live now",
    "live": "Live",
    "todayAt": "Today at "
  },
  "communityChat": {
    "online": "Online",
    "offline": "Offline",
    "placeholder": "Type a message...",
    "send": "Send"
  },
  "notifications": {
    "title": "Notifications",
    "settings": "Notification settings",
    "adminOnly": "This area is only available to administrators.",
    "groups": {
      "today": "Today",
      "yesterday": "Yesterday",
      "thisWeek": "This week",
      "older": "Older"
    },
    "empty": {
      "title": "You haven't received any notifications yet"
    },
    "meetingReminder": {
      "withCategory": "Your {category} meeting of {meetingName} starts in 15 minutes"
    },
    "pushNotifications": "Push notifications",
    "pushDescription": "Receive reminders and important messages from your recovery journey.",
    "whatYouWillReceive": "What you'll receive",
    "receiveList": "Meeting reminders, messages from your sponsor, sobriety milestones and community updates.",
    "privacyTitle": "Privacy",
    "privacyNote": "Your notifications are personal and secure. You can turn them off anytime in your device settings.",
    "statusAllowed": "Allowed",
    "statusDenied": "Denied",
    "statusSubscribed": "Subscribed",
    "statusNotSubscribed": "Not subscribed",
    "enabledSuccess": "Notifications enabled successfully!",
    "permissionDenied": "Notification permission denied. You can enable it in your device settings.",
    "disabled": "Notifications disabled",
    "disabledAlertMessage": "You will no longer receive push notifications. You can re-enable them anytime.",
    "understood": "Got it",
    "errorLoading": "Could not load notification settings. Please try again.",
    "serviceUnavailable": "Notification service is currently unavailable. Please try again later.",
    "unsupportedEnvironment": "Notifications are not supported in this environment.",
    "initializationFailed": "Failed to initialize notifications. Please try again.",
    "webUnsupported": "Notifications are not supported on web.",
    "expoGoUnsupported": "Notifications don't work in Expo Go. Use a development build.",
    "oneSignalNotConfigured": "The notification service is not configured.",
    "expoGoWarningTitle": "Expo Go detected",
    "expoGoWarningMessage": "Push notifications aren't available in Expo Go. Use a development or production build to test them.",
    "webWarningTitle": "Web version",
    "webWarningMessage": "Push notifications are not supported in the web version of the app.",
    "oneSignalWarningTitle": "Notifications not configured",
    "oneSignalWarningMessage": "The notification service hasn't been configured in this environment."
  },
  "account": {
    "changeEmail": {
      "title": "Change email",
      "subtitle": "Enter the new email address for your account.",
      "subtitleStep1": "For your security, first confirm your current password.",
      "currentEmail": "Current email:",
      "newEmail": "New email",
      "currentPassword": "Current password",
      "passwordPlaceholder": "Enter your current password",
      "emailPlaceholder": "Enter your new email",
      "button": "Change email",
      "backToProfile": "Back to profile",
      "errorPassword": "Incorrect password",
      "errorTooManyAttempts": "Too many login attempts. Wait a few minutes and try again.",
      "errorEmailInUse": "This email is already being used by another account",
      "errorRateLimit": "Too many email change attempts. Wait a few minutes before trying again.",
      "errorGeneric": "Error changing email",
      "errorUserInfo": "Error getting user information",
      "successTitle": "Email changed",
      "successMessage": "Your email has been changed successfully!",
      "confirmationTitle": "Verification sent",
      "confirmationMessage": "We sent a confirmation email to:",
      "confirmationInstructions": "Click the link in the email to confirm the change. You may need to check your spam folder."
    },
    "changePassword": {
      "title": "Change password",
      "subtitle": "Choose a new strong password to protect your account.",
      "currentPassword": "Current password",
      "newPassword": "New password",
      "confirmPassword": "Confirm new password",
      "passwordPlaceholder": "Enter your current password",
      "newPasswordPlaceholder": "Enter your new password",
      "confirmPasswordPlaceholder": "Confirm your new password",
      "requirements": "Your password must have:",
      "requirement1": "Minimum 8 characters",
      "requirement2": "One uppercase letter",
      "requirement3": "One lowercase letter",
      "requirement4": "One number",
      "button": "Change password",
      "buttonLoading": "Changing...",
      "errorUserInfo": "Error getting user information",
      "errorWrongPassword": "Current password incorrect",
      "errorPasswordMismatch": "Passwords don't match",
      "errorPasswordRequirements": "New password doesn't meet requirements",
      "errorSamePassword": "New password must be different from current",
      "successTitle": "Password changed",
      "successMessage": "Your password has been changed successfully!"
    },
    "changePhone": {
      "title": "Change phone",
      "titleSet": "Set phone",
      "subtitle": "For your security, please confirm your current password first.",
      "subtitleNew": "Enter the new phone number you want to use.",
      "subtitleFirst": "Enter your phone number to receive important notifications.",
      "currentPhone": "Current phone:",
      "label": "Phone number",
      "labelNew": "New number",
      "phoneNumber": "Phone number",
      "newPhoneNumber": "New number",
      "currentPassword": "Current password",
      "passwordPlaceholder": "Enter your current password",
      "phonePlaceholder": "(11) 99999-9999",
      "phoneHint": "Enter only numbers, we'll format automatically",
      "button": "Change phone",
      "buttonSet": "Set phone",
      "buttonLoading": "Saving...",
      "buttonContinue": "Continue",
      "verifying": "Verifying...",
      "errorPassword": "Incorrect password",
      "errorPasswordRequired": "Enter your current password",
      "errorInvalidPhone": "Please enter a valid number",
      "errorSamePhone": "New number must be different from current",
      "errorGeneric": "Error changing phone",
      "successTitle": "Phone changed",
      "successMessage": "Your phone number has been changed successfully!"
    },
    "changeName": {
      "title": "Change nickname",
      "subtitle": "Change your nickname to personalize your experience.",
      "label": "New nickname",
      "placeholder": "Enter your new nickname",
      "button": "Change nickname",
      "buttonLoading": "Saving...",
      "errorRequired": "Please enter a nickname",
      "errorUserNotFound": "User not found",
      "errorGeneric": "Unable to update nickname. Try again.",
      "successMessage": "Nickname updated successfully!"
    },
    "changeUsername": {
      "title": "Username",
      "subtitle": "Choose a unique username so others can mention you in the community.",
      "currentLabel": "Your current username",
      "label": "Username",
      "placeholder": "e.g. john.doe",
      "hint": "Letters, numbers, dots and underscores. Min. 3, max. 30 characters.",
      "checking": "Checking...",
      "available": "Available",
      "unavailable": "Already taken",
      "button": "Save username",
      "buttonLoading": "Saving...",
      "errorRequired": "Please choose a username",
      "errorUserNotFound": "User not found",
      "errorGeneric": "Could not update username. Try again.",
      "successMessage": "Username updated successfully!"
    },
    "deleteAccount": {
      "title": "Delete account",
      "question": "Are you sure you want to delete your account?",
      "warningTitle": "By deleting your account, you will lose:",
      "warningItem1": "All your sobriety and progress data",
      "warningItem2": "History of notes and reflections",
      "warningItem3": "Access to online meetings and community",
      "warningItem4": "Customized app settings",
      "warningItem5": "Access to Bill (virtual assistant)",
      "warningFooter": "This action cannot be undone. Your account and all data will be permanently deleted immediately.",
      "alternativeTitle": "Need a break?",
      "alternativeText": "If you're going through difficulties, consider talking to our support team before deleting your account. We're here to help.",
      "cancelButton": "Cancel",
      "deleteButton": "Delete account",
      "deleteButtonLoading": "Processing...",
      "confirmTitle": "Confirm deletion",
      "confirmMessage": "Are you sure you want to delete your account? All your data will be removed immediately and this action cannot be undone.",
      "confirmCancel": "Cancel",
      "confirmDelete": "Delete immediately",
      "errorUserNotFound": "Error: user not found",
      "errorSessionNotFound": "Error: session not found",
      "errorGeneric": "Error deleting account",
      "successMessage": "Account deleted successfully"
    },
    "subscription": {
      "title": "My Plan",
      "pageTitle": "My Plan",
      "basePlan": "Base",
      "activeBadge": "Active",
      "since": "since",
      "planDescriptionPlus": "Full access to the app's premium features and priority support.",
      "planDescriptionBase": "Free access to the app's features and community.",
      "upgradeTitle": "Padrinho Plus",
      "upgradeSubtitle": "Starting at $4.99/month",
      "providerText": "See all information and contact channels from your provider",
      "features": {
        "bill": {
          "title": "Bill, your digital sponsor",
          "description": "Smart conversations 24/7 for support and guidance (30 monthly messages)"
        },
        "billPlus": {
          "title": "Bill Plus",
          "description": "Your unlimited digital sponsor, connected to your diary, sobriety clock, and meeting check-ins to better support you on your journey"
        },
        "meetings": {
          "title": "Online meetings",
          "description": "Online meetings with multiple anonymous communities"
        },
        "exclusiveMeetings": {
          "title": "Exclusive meetings",
          "description": "Live exclusive meetings for Plus subscribers"
        },
        "exclusiveTrails": {
          "title": "Exclusive trails",
          "description": "Exclusive recovery trails for Plus subscribers"
        },
        "diary": {
          "title": "Diary & Check-ins",
          "description": "Record thoughts, feelings and attendance at online meetings"
        },
        "clock": {
          "title": "Sobriety clock",
          "description": "Mark your progress over time and celebrate every achievement"
        },
        "progress": {
          "title": "Real-time progress",
          "description": "Track your progress day by day"
        },
        "clinicConnection": {
          "title": "Clinic connection",
          "description": "Direct communication with your provider clinic"
        },
        "scheduling": {
          "title": "Scheduling & Professionals",
          "description": "Scheduling with professionals for support on your journey"
        }
      },
      "securityText": "All your data is protected and confidential",
      "termsLink": "Terms of Use (EULA)",
      "upgrade": "Upgrade to Plus",
      "successUpgrade": "Success!",
      "successUpgradeMessage": "Welcome to Padrinho Plus!",
      "error": "Error",
      "errorMessage": "Unable to open subscription screen.",
      "manageSubscription": "Manage subscription",
      "mySubscription": "My subscription",
      "errorTermsOfUse": "Unable to open Terms of Use."
    },
    "provider": {
      "title": "Provider",
      "phone": "Phone",
      "whatsapp": "WhatsApp",
      "email": "Email",
      "website": "Website",
      "websiteTitle": "Provider Website",
      "instagram": "Instagram",
      "schedule": "Schedule",
      "loading": "Loading...",
      "noData": "No provider information available",
      "attendance": "Service Hours",
      "contactChannels": "Contact Channels",
      "address": "Address",
      "providerNotFound": "Provider not found"
    },
    "interests": {
      "title": "My interests",
      "pageTitle": "Choose the topics you're most interested in",
      "subtitle": "Choose at least 3 topics of interest",
      "button": "Update my interests",
      "buttonLoading": "Saving...",
      "errorMinimum": "Please choose at least 3 topics of interest.",
      "errorUserNotFound": "Error: user not found",
      "errorGeneric": "Error updating interests. Try again.",
      "successMessage": "Interests updated successfully!"
    },
    "languageSettings": {
      "title": "Language",
      "button": "Choose"
    }
  },
  "profile": {
    "title": "Profile",
    "greeting": {
      "hello": "Hello, ",
      "wave": " 👋"
    },
    "sections": {
      "yourInfo": "Your information",
      "subscription": "Subscription",
      "security": "Security",
      "app": "Application",
      "padrinho": "Padrinho"
    },
    "fields": {
      "nickname": "Nickname",
      "username": "Username",
      "email": "Email",
      "phone": "Phone",
      "notInformed": "Not informed",
      "myPlan": "My plan",
      "basePlan": "Base",
      "provider": "Provider",
      "changePassword": "Change password",
      "myInterests": "My interests",
      "myInterestsSubtitle": "Configure what you see in the app",
      "language": "Language",
      "widget": "Widget",
      "widgetSubtitle": "Preview the home screen widget"
    },
    "languages": {
      "pt": "Português (Brasil)",
      "en": "English (United States)",
      "es": "Español (España)"
    },
    "upgrade": {
      "title": "Padrinho Plus",
      "subtitle": "Starting at $4.99/mo"
    },
    "csat": {
      "title": "How is your app experience?",
      "subtitle": "Tell us"
    },
    "logout": {
      "title": "Sign Out",
      "message": "Are you sure you want to sign out of your account?",
      "cancel": "Cancel",
      "confirm": "Sign Out"
    },
    "deleteAccount": {
      "label": "Delete my account"
    },
    "defaults": {
      "userName": "User"
    },
    "share": {
      "inviteTitle": "Invite to Padrinho",
      "shareError": "Error sharing",
      "inviteMessage": "Hi! I discovered an amazing app that's really helping me in my recovery. It's called Padrinho and has online meetings, sobriety clock and much more. Download it here: https://www.padrinho.app/downloads"
    },
    "cards": {
      "compass": {
        "tag": "Compass",
        "title": "Information is your north star for recovery!",
        "subtitle": "Access the blog"
      },
      "community": {
        "tag": "Community",
        "title": "Share your story and experience with other members",
        "subtitle": "Join WhatsApp"
      },
      "podcast": {
        "tag": "On the Trail",
        "title": "Audio content to complement your program",
        "subtitle": "Listen on Spotify"
      },
      "invite": {
        "title": "Invite someone to Padrinho",
        "subtitle": "Share the invitation"
      }
    },
    "menu": {
      "title": "Menu",
      "hello": "Hello,",
      "moreContent": "More content",
      "diaryTitle": "Diary",
      "diarySubtitle": "Notes, feelings and messages"
    },
    "errors": {
      "loadProfile": "Error loading profile",
      "retry": "Try Again",
      "backToLogin": "Back to Login",
      "userNotFound": "User not found",
      "userDataError": "Unable to load user data",
      "makeLogin": "Log In"
    },
    "toasts": {
      "phoneChangedSuccess": "Phone changed successfully!",
      "authError": "Authentication error. Try again.",
      "noImageSelected": "No image selected",
      "invalidFile": "Invalid file",
      "uploadingPhoto": "Uploading photo...",
      "uploadFailed": "Unable to upload image",
      "photoUpdated": "Profile photo updated!",
      "permissionRequired": "Permission required to access gallery",
      "connectionError": "Connection error. Try again.",
      "permissionDenied": "Permission denied to access gallery",
      "photoUpdateError": "Error updating profile photo",
      "unexpectedError": "Unexpected error. Try again.",
      "nameUpdateError": "Error updating name",
      "nameSaved": "Name saved successfully!",
      "logoutError": "Error logging out",
      "plusUpgradeSuccess": "Congratulations! You now have access to Padrinho Plus!",
      "paywallError": "Unable to open subscription screen.",
      "subscriptionManagementError": "Unable to open subscription management."
    }
  },
  "common": {
    "save": "Save",
    "cancel": "Cancel",
    "delete": "Delete",
    "edit": "Edit",
    "close": "Close",
    "back": "Back",
    "next": "Next",
    "loading": "Loading...",
    "error": "Error",
    "success": "Success!",
    "confirm": "Confirm",
    "yes": "Yes",
    "no": "No",
    "and": "and",
    "of": "of",
    "apply": "Apply",
    "clearFilters": "Clear filters",
    "now": "Now",
    "today": "Today",
    "tomorrow": "Tomorrow",
    "yesterday": "Yesterday",
    "months": {
      "january": "January",
      "february": "February",
      "march": "March",
      "april": "April",
      "may": "May",
      "june": "June",
      "july": "July",
      "august": "August",
      "september": "September",
      "october": "October",
      "november": "November",
      "december": "December"
    },
    "weekdays": {
      "short": {
        "sunday": "Sun",
        "monday": "Mon",
        "tuesday": "Tue",
        "wednesday": "Wed",
        "thursday": "Thu",
        "friday": "Fri",
        "saturday": "Sat"
      },
      "long": {
        "sunday": "Sunday",
        "monday": "Monday",
        "tuesday": "Tuesday",
        "wednesday": "Wednesday",
        "thursday": "Thursday",
        "friday": "Friday",
        "saturday": "Saturday"
      }
    },
    "periods": {
      "morning": "Morning",
      "afternoon": "Afternoon",
      "evening": "Evening"
    },
    "categories": {
      "supportGroup": "Support Group",
      "workshop": "Workshop",
      "meditation": "Meditation",
      "therapy": "Therapy",
      "sharing": "Sharing",
      "reuniaoNovos": "Newcomers Meeting",
      "reuniaoPartilhas": "Sharing Meeting",
      "reuniaoTematica": "Themed Meeting",
      "reuniaoEstudoLiteratura": "Literature Study",
      "reuniaoAteusAgnosticos": "Atheists & Agnostics",
      "reuniaoLgbtqiapn": "LGBTQIAPN+",
      "reuniaoCodependentes": "Codependents",
      "reuniaoPassos": "Steps Meeting",
      "reuniaoTradicoes": "Traditions Meeting"
    },
    "alert": {
      "errorTitle": "Error",
      "successTitle": "Success!",
      "infoTitle": "Information"
    }
  },
  "calendar": {
    "title": "Feelings diary",
    "congratsGreeting": "Congratulations!",
    "congratsMiddle": " You logged ",
    "congratsCountUnit": "feelings",
    "congratsEnd": " in the last 7 days"
  },
  "filters": {
    "author": {
      "you": "You",
      "bill": "Bill"
    },
    "period": {
      "last7days": "Last 7 days",
      "last15days": "Last 15 days",
      "last30days": "Last 30 days"
    },
    "time": "Time",
    "dayOfWeek": "Day of week"
  },
  "group": {
    "title": "Group",
    "filters": {
      "time": "Time",
      "dayOfWeek": "Day of week",
      "category": "Category"
    },
    "errors": {
      "notFound": "Group not found",
      "noMeetings": "No meetings found"
    },
    "liveNow": "Live now",
    "todayAt": "Today at"
  },
  "meeting": {
    "liveNow": "Live now",
    "startsInMinutes": "Starts in {minutes} {unit}",
    "startsInHours": "Starts in {hours} {unit}",
    "startsInHoursMinutes": "Starts in {hours}h{minutes}",
    "endedMinutesAgo": "Ended {minutes} {unit} ago",
    "endedHoursAgo": "Ended {hours}h{minutes} ago",
    "timeError": "Error calculating time",
    "timeNotSpecified": "Time not specified",
    "notSpecified": "Not specified",
    "everyDay": "Every day",
    "mondayToFriday": "Monday to Friday",
    "weekends": "Weekends",
    "everyDayName": "Every {day}",
    "and": "and",
    "andOthers": "and others",
    "minute": "minute",
    "minutes": "minutes",
    "hour": "hour",
    "hours": "hours",
    "errors": {
      "loadFailed": "Could not load meeting information",
      "loginRequired": "You must be logged in to join the meeting",
      "linkUnavailable": "Meeting link not available"
    }
  },
  "email": {
    "errors": {
      "notFound": "Email not found",
      "resendFailed": "Error resending link. Please try again.",
      "unexpectedError": "Unexpected error. Please try again."
    },
    "success": {
      "resent": "Link resent successfully!"
    }
  },
  "community": {
    "header": {
      "title": "Community"
    },
    "tabs": {
      "forYou": "For You",
      "following": "Following"
    },
    "author": {
      "anonymous": "Anonymous",
      "default": "User"
    },
    "emptyState": {
      "title": "Your footsteps are marked here in the community!",
      "subtitle": "Leave your message for members who are still arriving"
    },
    "actions": {
      "options": "Options",
      "editPost": "Edit post",
      "deletePost": "Delete post"
    },
    "toast": {
      "postRemoved": "Post removed successfully",
      "postRemoveError": "Error removing post",
      "postUpdated": "Post updated successfully",
      "postUpdateError": "Error updating post"
    },
    "timestamp": {
      "now": "Now",
      "yesterday": "Yesterday"
    },
    "newPost": {
      "titleComment": "New Comment",
      "titlePost": "New Testimony",
      "editTitle": "Edit post",
      "publish": "Publish",
      "save": "Save",
      "cancel": "Cancel",
      "addTopic": "Add topic",
      "topicsCount": "{count} topics",
      "placeholder": "What's on your mind right now?",
      "defaultUser": "User"
    },
    "post": {
      "headerTitle": "Community",
      "firstToEncourage": "Be the first to encourage!",
      "commentPlaceholder": "Write an encouragement...",
      "options": "Options",
      "editPost": "Edit post",
      "deletePost": "Delete post",
      "postRemoved": "Post removed successfully",
      "postRemoveError": "Error removing post",
      "anonymous": "Anonymous",
      "defaultAuthor": "User",
      "timestampNow": "Now"
    },
    "publishing": {
      "publishing": "Publishing...",
      "error": "Could not publish",
      "success": "Published successfully!"
    },
    "topics": {
      "title": "Topics",
      "save": "Save",
      "searchPlaceholder": "Search topic…",
      "notFound": "No topics found",
      "labels": {
        "Abstinência": "Abstinence",
        "Adultos 60+": "Adults 60+",
        "Álcool": "Alcohol",
        "Ansiedade": "Anxiety",
        "Apadrinhamento": "Sponsorship",
        "Autocompaixão": "Self-Compassion",
        "Autoconhecimento": "Self-Knowledge",
        "Autocontrole": "Self-Control",
        "Bariátrica": "Bariatric",
        "Burnout": "Burnout",
        "Comunicação": "Communication",
        "Compras Compulsivas": "Compulsive Shopping",
        "Dependência Digital": "Digital Addiction",
        "Depressão": "Depression",
        "Drogas / Psicoativos": "Drugs / Psychoactives",
        "Emoções": "Emotions",
        "Estresse": "Stress",
        "Família": "Family",
        "Feminilidade": "Femininity",
        "Gatilhos": "Triggers",
        "Internação": "Hospitalization",
        "Jogos": "Gambling",
        "Juventude": "Youth",
        "LGBT+": "LGBT+",
        "Limites": "Boundaries",
        "Lucidez": "Clarity",
        "Masculinidade": "Masculinity",
        "Maternidade": "Motherhood",
        "Neurodivergência": "Neurodivergence",
        "Novos na Recuperação": "New to Recovery",
        "Outras Dependências": "Other Addictions",
        "Paternidade": "Fatherhood",
        "Pornografia": "Pornography",
        "Prevenção de Recaída": "Relapse Prevention",
        "Psiquiatria & Medicação": "Psychiatry & Medication",
        "Raiva": "Anger",
        "Recomeços": "Fresh Starts",
        "Rede de Apoio": "Support Network",
        "Redes Sociais": "Social Media",
        "Relacionamentos": "Relationships",
        "Ressaca": "Hangover",
        "Rotina de Sobriedade": "Sobriety Routine",
        "Sexo": "Sex",
        "Sobriedade Longa": "Long-term Sobriety",
        "Solidão": "Loneliness",
        "Terapia": "Therapy",
        "Transtornos Alimentares": "Eating Disorders",
        "Tratamento": "Treatment",
        "Vergonha & Culpa": "Shame & Guilt",
        "Vida Sexual Saudável": "Healthy Sexual Life"
      }
    }
  },
  "padrinho": {
    "website": "Website",
    "privacy": "Privacy and Terms of Use",
    "help": "Help"
  },
  "csat": {
    "pageTitle": "Feedback",
    "title": "Rate your experience with the Padrinho app",
    "starsInstruction": "Choose from 1 to 5 stars to rate",
    "topicsTitles": {
      "negative": "What's wrong?",
      "neutral": "What can be better?",
      "positive": "What did you like?"
    },
    "topics": {
      "negative": {
        "crashes": "Crashes",
        "slowPerformance": "Slow performance",
        "confusingNavigation": "Confusing navigation",
        "billResponses": "Bill's responses",
        "notifications": "Notifications",
        "design": "Design",
        "meetings": "Meetings",
        "trail": "12-step trail",
        "diary": "Emotional diary"
      },
      "neutral": {
        "navigation": "Navigation",
        "billQuality": "Bill's quality",
        "design": "Design",
        "performance": "Performance",
        "notifications": "Notifications",
        "meetings": "Meetings",
        "trail": "12-step trail",
        "diary": "Emotional diary",
        "community": "Community"
      },
      "positive": {
        "easeOfUse": "Easy to use",
        "billHelp": "Bill's help",
        "design": "Beautiful design",
        "meetings": "Meetings",
        "trail": "12-step trail",
        "diary": "Emotional diary",
        "sobrietyClock": "Sobriety clock",
        "community": "Community",
        "notifications": "Notifications"
      },
      "other": "Other"
    },
    "commentTitle": "Leave your comment",
    "commentPlaceholder": "Tell us more about your experience...",
    "submit": "Submit feedback",
    "submitting": "Submitting...",
    "alerts": {
      "selectRating": "Please select a rating",
      "error": "Error submitting feedback. Please try again."
    },
    "success": {
      "title": "Thank you for your feedback!",
      "subtitle": "Your feedback has been submitted successfully. It is very important for us to continue improving the app.",
      "button": "Go back"
    },
    "callTitle": "Rate your call experience",
    "callTopics": {
      "negative": {
        "audioQuality": "Audio quality",
        "videoQuality": "Video quality",
        "connectionDrops": "Connection drops",
        "sponsorPreparedness": "Sponsor preparedness",
        "scheduling": "Scheduling"
      },
      "neutral": {
        "audioQuality": "Audio quality",
        "videoQuality": "Video quality",
        "sponsorPreparedness": "Sponsor preparedness",
        "callDuration": "Call duration",
        "scheduling": "Scheduling"
      },
      "positive": {
        "clearAudio": "Clear audio",
        "clearVideo": "Clear video",
        "sponsorHelp": "Sponsor's help",
        "easyToConnect": "Easy to connect",
        "callDuration": "Call duration"
      }
    },
    "trailTitle": "What did you think of the content?",
    "trailTopics": {
      "negative": {
        "contentDifficult": "Hard to understand",
        "contentNotRelevant": "Not relevant to me",
        "contentTooShort": "Too short",
        "contentTooLong": "Too long",
        "contentFewExamples": "Not enough practical examples",
        "audioQuality": "Audio quality"
      },
      "neutral": {
        "contentDepth": "Depth of content",
        "contentPace": "Reading pace",
        "contentExamples": "Practical examples",
        "contentLanguage": "Language used",
        "audioExperience": "Audio experience"
      },
      "positive": {
        "contentClarity": "Clear content",
        "contentHelpful": "Helped my recovery",
        "contentRelevant": "Relevant content",
        "contentExamples": "Great practical examples",
        "audioQuality": "Great audio"
      }
    }
  },
  "postCallCsat": {
    "sessionEnded": "Session ended",
    "headline": "Tell us about your experience",
    "rate": "Rate my experience",
    "skip": "Maybe later"
  },
  "appointments": {
    "title": "Appointments",
    "upcoming": "Upcoming sessions",
    "history": "Past sessions",
    "discoveryTitle": "Find the right professionals to support you on your journey",
    "discoveryChips": "Abstinence,Masculinity,Money,Treatment,Experience",
    "findProfessionals": "Find professionals",
    "discoveryError": "We couldn't load professionals right now.",
    "noPastInline": "You don't have any past appointments",
    "newAppointment": "New appointment",
    "contextTitle": "Options",
    "reschedule": "Reschedule",
    "cancel": "Cancel",
    "cancelAppointment": "Cancel appointment",
    "cancelTitle": "Cancel appointment",
    "cancelMessage": "Are you sure you want to cancel this appointment?",
    "cancelSuccess": "Appointment canceled successfully",
    "cancelError": "Error canceling appointment",
    "changeWindowDisclaimer": "Cancellation or rescheduling is only available until 24 hours before the session. After that, you can no longer cancel or reschedule.",
    "changeWindowClosed": "You can't cancel or reschedule within 24 hours of the session.",
    "loadError": "Error loading appointments",
    "pendingPayment": "Pending payment",
    "completePayment": "Complete payment"
  },
  "sponsors": {
    "details": {
      "crp": "CRP",
      "session": "Session",
      "price": "Price per session",
      "durationMinutes": "{minutes} minutes",
      "sessionDuration": "Session of {minutes} minutes"
    },
    "scheduleSession": "Schedule session",
    "profile": {
      "findSponsorTitle": "Find a professional",
      "findSponsorSubtitle": "Schedule an appointment",
      "scheduledTitle": "Appointments",
      "role": "My Sponsor",
      "scheduledFor": "Scheduled for",
      "at": "at",
      "scheduledDate": "Scheduled for {{date}} at {{time}}",
      "whatsappButton": "Send message",
      "saveToCalendar": "Save to calendar",
      "joinRoom": "Join the session",
      "joinRoomLoading": "Opening session…",
      "joinRoomTooEarly": "Available 15 min before",
      "joinRoomError": "We couldn't open the session. Please try again in a few seconds.",
      "menuTitle": "Options",
      "cancelAppointment": "Cancel appointment",
      "cancelTitle": "Cancel appointment",
      "cancelMessage": "Are you sure you want to cancel this appointment?",
      "cancelSuccess": "Appointment canceled successfully",
      "cancelError": "Error canceling appointment",
      "rescheduleSession": "Reschedule session",
      "rescheduleTitle": "Reschedule session",
      "rescheduleSuccess": "Session rescheduled successfully!",
      "rescheduleError": "Error rescheduling the session",
      "reschedulePastError": "Cannot reschedule a session that has already passed",
      "rescheduleSlotTaken": "This time slot is no longer available",
      "changeWindowClosed": "You can't reschedule within 24 hours of the session."
    },
    "list": {
      "title": "Professionals",
      "subtitle": "Here are some sponsor suggestions for you",
      "padrinho": "Sponsor",
      "madrinha": "Sponsor",
      "viewAgendaButton": "Schedule session",
      "loading": "Loading suggestions...",
      "error": "Error loading sponsors",
      "empty": "No sponsors available at the moment"
    },
    "agenda": {
      "title": "Schedule",
      "sessionDuration": "45-minute sessions",
      "schedules": "Schedules from",
      "to": "to",
      "dateRange": "Schedules from {{startDate}} to {{endDate}}",
      "selectTime": "{{date}} at {{time}}",
      "confirmButton": "Confirm time",
      "loading": "Loading schedule...",
      "error": "Error loading times",
      "noSlots": "No times available",
      "rescheduleConfirmButton": "Confirm reschedule",
      "rescheduling": "Rescheduling..."
    },
    "phone": {
      "headerTitle": "Contact",
      "title": "Confirm your mobile number",
      "subtitle": "This will be how the professional contacts you if necessary.",
      "placeholder": "( __ ) _____ - ____",
      "confirmButton": "Confirm and schedule",
      "confirming": "Confirming...",
      "saveError": "We couldn't save your phone number. Please try again."
    },
    "payment": {
      "headerTitle": "Payment",
      "title": "Review payment",
      "scheduledFor": "Appointment on {date} at {time}",
      "methodTitle": "Payment method",
      "interimNotice": "No online charge will be made yet. At this step, you are only confirming the appointment.",
      "pix": "Pix",
      "card": "Card",
      "comingSoon": "Coming soon",
      "amountLabel": "Amount to pay",
      "priceUnavailable": "Unable to load the amount",
      "confirmButton": "Complete payment",
      "invalidContext": "We couldn't validate the appointment details. Go back and choose the time again.",
      "phoneMissing": "Please confirm your phone number again before booking.",
      "checkoutError": "We could not complete the payment. Your time will be released if payment is not confirmed.",
      "finalizationPending": "Your payment is still being confirmed. Check your appointments again in a moment.",
      "refundStartedTitle": "We couldn't confirm your session",
      "refundStartedMessage": "Your payment was approved, but the time could not be reserved. A full refund has started automatically, and you don't need to do anything.",
      "refundCompletedTitle": "Payment refunded",
      "refundCompletedMessage": "Your payment was refunded. The time it takes to appear depends on your financial institution."
    },
    "success": {
      "header": "Appointment",
      "title": "Appointment scheduled successfully",
      "subtitlePrefix": "We will notify",
      "subtitleSuffix": "about your appointment",
      "button": "View my appointments",
      "buttonCsat": "Rate your experience",
      "rescheduleHeader": "Reschedule",
      "rescheduleTitle": "Session rescheduled successfully",
      "rescheduleSubtitlePrefix": "We will notify",
      "rescheduleSubtitleSuffix": "about the new time",
      "rescheduleButton": "View my appointments"
    },
    "enableNotifications": {
      "header": "Notifications",
      "title": "Enable your notifications!",
      "subtitle": "This way we can notify you about your conversation with {{sponsorName}}",
      "settingsButton": "Go to settings",
      "skipButton": "Not now!"
    },
    "weekdays": {
      "monday": "Monday",
      "tuesday": "Tuesday",
      "wednesday": "Wednesday",
      "thursday": "Thursday",
      "friday": "Friday",
      "saturday": "Saturday",
      "sunday": "Sunday"
    },
    "errors": {
      "title": "Error",
      "notPlusUser": "This feature is exclusive to Padrinho Plus subscribers",
      "loadError": "Error loading information",
      "scheduleError": "Error scheduling appointment",
      "slotTaken": "This time is no longer available",
      "invalidPhone": "Please enter a valid phone number"
    }
  },
  "biometric": {
    "loginButton": "Sign in with Face ID",
    "loginButtonFingerprint": "Sign in with fingerprint",
    "enableTitle": "Sign in faster",
    "enableDescription": "Use biometrics to sign in to Padrinho without typing your password.",
    "enableButton": "Enable biometrics",
    "notNow": "Not now",
    "settingTitle": "Face ID",
    "settingTitleFingerprint": "Biometrics",
    "settingSubtitle": "Sign in without typing your password",
    "disableConfirmTitle": "Disable biometrics?",
    "disableConfirmMessage": "You will need to type your password to sign in.",
    "disableConfirmYes": "Disable",
    "disableConfirmNo": "Cancel",
    "authReason": "Confirm your identity to sign in to Padrinho",
    "unavailable": "Not available on this device"
  },
  "consent": {
    "updateTitle": "Updated Terms",
    "updateMessage": "Our Terms of Service and Privacy Policy have been updated. Please review and accept to continue using the app.",
    "viewTerms": "Read Terms and Privacy Policy",
    "acceptCheckbox": "I have read and accept the updated Terms of Service and Privacy Policy",
    "acceptButton": "Accept and Continue",
    "acceptingButton": "Saving...",
    "errorTitle": "Error",
    "errorMessage": "Could not record your consent. Please try again."
  },
  "widget": {
    "preview": {
      "title": "Widget Preview",
      "label": "Medium Widget (349 × 164)",
      "labelSmall": "Small Widget (164 × 164)"
    },
    "guide": {
      "title": "Home Screen Widget",
      "subtitle": "See your sobriety counter right on your home screen.",
      "done": "Got it",
      "ios": {
        "step1": "Long press on an empty area of your home screen",
        "step2": "Tap the \"+\" button in the top corner",
        "step3": "Search for \"Padrinho\" in the search bar",
        "step4": "Choose your preferred widget size",
        "step5": "Tap \"Add Widget\" to confirm"
      },
      "android": {
        "step1": "Long press on an empty area of your home screen",
        "step2": "Tap \"Widgets\" in the menu that appears",
        "step3": "Find \"Padrinho\" in the widget list",
        "step4": "Long press the widget and drag it to your home screen"
      }
    }
  },
  "usernamePrompt": {
    "title": "Your @handle has been created",
    "description": "Other community members can mention you in posts using your handle.",
    "gotIt": "Got it",
    "customize": "Customize handle"
  },
  "missoes": {
    "tabLabel": "Missions",
    "todayHeading": "Your missions for today",
    "todayDateLabel": "Today, {date}",
    "empty": "No missions today. Come back tomorrow.",
    "goalCard": {
      "title": "My goal",
      "stagePill": "Stage {stageNumber} · {stageName}",
      "askBill": "Ask Bill",
      "sobrietyFooter": "You've been sober for {days} days",
      "setSobriety": "Set sobriety time"
    },
    "encontros": {
      "heading": "Meetings",
      "weekIntro": "Your attendance over the last 7 days",
      "encouragement": "Way to go! You attended <b>{count} meetings</b> in the last 7 days",
      "encouragementOne": "Way to go! You attended <b>1 meeting</b> in the last 7 days",
      "encouragementZero": "You haven't attended any meetings this week yet"
    },
    "weekdays": {
      "sun": "Sun",
      "mon": "Mon",
      "tue": "Tue",
      "wed": "Wed",
      "thu": "Thu",
      "fri": "Fri",
      "sat": "Sat"
    },
    "missions": {
      "participar_encontro": {
        "label": "Attend a meeting",
        "helper": "Check in to a meeting"
      },
      "registrar_diario_sentimentos": {
        "label": "Log in your feelings diary",
        "helper": "Capture an emotion from your day"
      },
      "progredir_trilha": {
        "label": "Make progress on a trail",
        "helper": "Pick up where you left off"
      },
      "apoiar_membro_comunidade": {
        "label": "Support a community member",
        "helper": "React or comment on a post"
      },
      "publicar_comunidade": {
        "label": "Post in the community",
        "helper": "Share something with people on the same path"
      },
      "doneA11y": "completed"
    },
    "history": {
      "heading": "History",
      "yesterdayDateLabel": "Yesterday, {date}",
      "dateNamed": "{date}",
      "week": "Week",
      "month": "1 Month",
      "threeMonths": "3 Months",
      "sixMonths": "6 Months",
      "twelveMonths": "12 Months",
      "view": "View",
      "close": "Close",
      "completedSummary": "You completed {done} of {total} missions",
      "loading": "Loading...",
      "loadFailed": "Couldn't load this day.",
      "relapseMessage": "There was a fresh start — don't give up!",
      "supports": {
        "one": {
          "bold": "1 person",
          "suffix": " received your support"
        },
        "many": {
          "bold": "{count} people",
          "suffix": " received your support"
        }
      },
      "posts": {
        "many": "You shared {count} reflections with the community",
        "anonymous": "Anonymous",
        "you": "You"
      },
      "timeAgo": {
        "minute": "{n}m ago",
        "hour": "{n}h ago",
        "day": "{n}d ago"
      }
    },
    "origin": {
      "youArrivedAt": "You arrived at Padrinho"
    },
    "errors": {
      "loadFailed": "We couldn't load your missions right now.",
      "retry": "Try again"
    }
  },
  "stageTransition": {
    "eyebrow": "NEW STAGE",
    "title": "You've moved to {stageName}",
    "body": "{stageDescription}",
    "transitionLabel": "{from} → {to}",
    "primaryCta": "Continue my journey",
    "secondaryCta": "Later"
  },
  "currentStage": {
    "headerTitle": "Your stage",
    "eyebrow": "MY CURRENT STAGE",
    "stageLabel": "Stage {n} of 5",
    "primaryCta": "Ok, got it"
  },
  "changeGoal": {
    "headerTitle": "Goal",
    "bodyTitle": "Define your main goal within the app",
    "cta": "Set my goal"
  },
  "billAsk": {
    "goalQuestion": "How can I develop my goal of \"{goal}\"?",
    "stageQuestion": "How can I make progress in my current recovery stage?"
  },
  "recoveryStages": {
    "1": {
      "name": "Beginning",
      "description": "You're in the early phase. Stay close to intensive support — it's essential right now.",
      "defaultGoal": "Take care of myself today, one moment at a time."
    },
    "2": {
      "name": "Foundation",
      "description": "You're taking the first steps. The base is still fragile; daily engagement makes all the difference.",
      "defaultGoal": "Build a routine that supports my sobriety."
    },
    "3": {
      "name": "Developing",
      "description": "Healthy patterns are starting to form. Keeping consistency is the focus of this phase.",
      "defaultGoal": "Deepen what works and discover new strengths."
    },
    "4": {
      "name": "Strengthening",
      "description": "Solid progress and growing confidence. Keep reinforcing the habits you've built.",
      "defaultGoal": "Keep what works and tend to the bonds that matter."
    },
    "5": {
      "name": "Maintenance",
      "description": "Your recovery is stable. It's time to rebuild the areas of life affected by dependency.",
      "defaultGoal": "Sustain my sobriety and give back to those starting out."
    }
  }
}
